import type { DataGridRef } from '@myosh/odin-components';
import { BehaviorSubject } from 'rxjs';

interface DataGridRefContext {
  isRecordsListGrid?: boolean;
}

export type DataGridRefWithContext = DataGridRef & { context?: DataGridRefContext };

const dataGridSubject = new BehaviorSubject<DataGridRefWithContext | null>(null);

export function getDataGridReference() {
  return dataGridSubject.asObservable();
}

export function setDataGridReference(dataGridRef: DataGridRef, context?: DataGridRefContext) {
  const refWithContext = dataGridRef as DataGridRefWithContext;
  if (context) {
    refWithContext.context = context;
  }
  dataGridSubject.next(refWithContext);
}

export function clearDataGridReference() {
  dataGridSubject.next(null);
}
